import React, { useEffect } from "react";
import styled from "@emotion/styled";
import Lottie from "react-lottie";
import animationData from "images/lottie/loading.json";

const loadingDefaultOption = {
  animationData
};

const Loading: React.FunctionComponent = () => {
  useEffect(() => {
    function handleTouchWindow(e: any) {
      e.preventDefault();
    }

    document.body.classList.add("scrollHidden");
    window.addEventListener("touchmove", handleTouchWindow, {
      passive: false
    });

    return () => {
      document.body.classList.remove("scrollHidden");
      window.removeEventListener("touchmove", handleTouchWindow);
    };
  });

  return (
    <LoadingLayer id="jsDimLoading">
      <LoadingImg>
        <Lottie
          options={loadingDefaultOption}
          isStopped={false}
          isPaused={false}
        />
      </LoadingImg>
    </LoadingLayer>
  );
};

const LoadingLayer = styled.div`
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
`;

const LoadingImg = styled.div`
  width: 60px;
  height: 60px;
`;

export default Loading;
